<template>
  <Modal
    v-model="_value"
    width="400"
    title="指派维修员"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Form :model="maintainOrder" :label-width="80">
      <FormItem prop="maintainerId" label="维修员">
        <Select class="field" v-model="maintainOrder.maintainerId">
          <Option v-for="item in maintainers" :value="item.id" :key="item.realName===null?item.name:item.realName">{{item.realName===null?item.name:item.realName}}</Option>
        </Select>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'maintainorderchangemaintainermodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      maintainers: [],
      maintainOrder: {
        id: null,
        maintainerId: null
      }
    }
  },
  methods: {
    ...mapActions([
      'MaintainOrderServ_ChangeMaintainer',
      'UserServ_GetAllUsers',
      'MaintainOrderServ_GetDetail'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认指派维修员</p>',
        onOk: () => {
          store.dispatch('MaintainOrderServ_ChangeMaintainer', { params: this.maintainOrder }).then(() => {
            this.$Message.success('指派维修员成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.maintainOrder.id = null
        this.maintainOrder.maintainerId = null

        let maintainOrderId = this._initValue
        if (maintainOrderId) {
          store.dispatch('MaintainOrderServ_GetDetail', {
            params: { id: maintainOrderId }
          }).then(() => {
            this.maintainOrder = store.getters.get_MaintainOrder_GetDetailResult
          }).catch(err => {
            this.$Message.error(err)
          })
        }

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8] }
        }).then(() => {
          this.maintainers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
